import { bootstrapTenant } from '@octawash/shared';
import React from 'react';
import ReactDOM from 'react-dom/client';

import { App } from './App';
import './lib/i18n';
import { registerServiceWorker } from './lib/register-sw';
import { initSentry, maybeInitOnConsent } from './lib/sentry';
import './index.css';

// Sprint BBBB: tenta init imediato (se consentimento já foi dado em
// visita anterior). Se não, registra listener para iniciar quando
// CookieBanner emitir 'octawash:consent-changed'.
initSentry();
window.addEventListener('octawash:consent-changed', maybeInitOnConsent);

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root não encontrado em index.html');

// Sprint H: bootstrap de tenant ANTES do app renderizar. Resolve custom
// domains (cliente acessando wash.redemontecarlo.com.br) via RPC. Para
// domínios OctaWash conhecidos é sync (zero latência).
const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

async function iniciar() {
  if (url && anonKey) {
    await bootstrapTenant({
      hostname: window.location.hostname,
      supabaseUrl: url,
      anonKey,
      fallbackTenant: import.meta.env.VITE_DEFAULT_TENANT_SUBDOMAIN ?? null,
    });
  }

  ReactDOM.createRoot(rootEl!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );

  // Sprint U: PWA — registra service worker após render inicial
  registerServiceWorker();
}

void iniciar();
